
import styles from './accordianLayout.scss';
import CustomStatusFlag from '../../../../Common/CommonComponents/StatusTab/statusTab';
import CustomAnchorTag from '../../../../Common/CommonComponents/CustomAnchorTag/customAnchorTag';
import React, { Component } from 'react';
export default class AccordianLayout extends Component {
    constructor(props) {
        super(props);
        this.isMobileView = app.appUtil.detectMobile();
        this.state = {
            serviceAccountDetails: [], saFilteredList: [], noOfShowMoreSAList: 3, showMoreLink: false,
            showLessLink: false, globalError: false, isError: false, noOfSainRow: 3,totalSACount:0
        };
    }


    getDatas = (colimit = 3, coOffset = 0,firstTime=0) => {

        if(this.props.searchDataServiceList.length && firstTime){
            let filteredList = [...this.state.saFilteredList,...this.props.searchDataServiceList];

            this.setState({
                saFilteredList:filteredList,
                showMoreLink:this.props.totalSACount>filteredList.length,showLessLink:this.props.totalSACount>3 && this.props.totalSACount<=filteredList.length,totalSACount:this.props.totalSACount
            });
        }else{
            let reqObj = {
                contractAccountNumber: this.props.customerNo,
                sortOption: "ContractNumber",
                coOffset: coOffset,
                colimit: colimit,
                txnName:"RES_241",
                sortDirection:"ASC"
            };
            this.props.setInnerTableLoader(true);
            app.settingsService.getSADetails(reqObj).then(
                (response) => {
                    
                    let saDetail = response.customerAccountList[0].serviceAccountList;
                    let filteredList = [...this.state.saFilteredList,...saDetail];
                    this.setState((prevState)=>({
                        saFilteredList:filteredList,showMoreLink:this.props.totalSACount>filteredList.length,showLessLink: this.props.totalSACount<=filteredList.length,totalSACount:this.props.totalSACount
                    }));
                    this.props.setInnerTableLoader(false);
    
                }, (error) => {
                    this.props.setInnerTableLoader(false);
                    this.setState({ globalError: true, isError: true });
                });
        }
        

    }

    componentDidUpdate(prevProps) {
        if (this.props.customerNo !== prevProps.customerNo || this.props.clickOnXBtn ) {
            this.setState({saFilteredList:[]});
            this.props.handleClickOnXBtn(false);
            this.getDatas();
        }
    }

    componentDidMount() {
        this.getDatas(3,0,1);
    }


    handleClickMore = () => {
        let events = {
            alertDismissed:false, alertInteracted:false, manageAccount:false, makePayment:false, autoPayEnroll:false, paperlessEnroll:false, viewBill:false, viewUsage:false, custom:false, autopayCancel:false, paperlessCancel:false, sdpEnroll:false, sepEnroll:false, savingsPlan:false, paymentArrangement:false,componentClick:true,componentName:'multi_grid'
        };
        app.analyticsService.addPageLevelData('eventCapturing', events);
        window.aUtils ? window.aUtils.sendAAEvent("link", `settings|accounts|multi_grid|none|page|show_more`) : null;
        let totalList = this.state.totalSACount;
        let newListLength = this.state.noOfShowMoreSAList + 45;
        if (totalList <= newListLength) {
            this.setState({ showMoreLink: false, showLessLink: true });
        }
        this.getDatas(45,this.state.noOfShowMoreSAList);
        this.setState({ noOfShowMoreSAList: newListLength });


    }
    handleClickLess = () => {
        let events = {
            alertDismissed:false, alertInteracted:false, manageAccount:false, makePayment:false, autoPayEnroll:false, paperlessEnroll:false, viewBill:false, viewUsage:false, custom:false, autopayCancel:false, paperlessCancel:false, sdpEnroll:false, sepEnroll:false, savingsPlan:false, paymentArrangement:false,componentClick:true,componentName:'multi_grid'
        };
        app.analyticsService.addPageLevelData('eventCapturing', events);
        window.aUtils ? window.aUtils.sendAAEvent("link", `settings|accounts|multi_grid|none|page|show_less`) : null;
        let scrollID = `scroll${this.props.index}`;
        let element = document.getElementById(scrollID);
        setTimeout(() => {
            let top = element.getBoundingClientRect().top + document.documentElement.scrollTop - 50;

            window.scrollTo({ top: top, behavior: "smooth" });
        }, 500);

        this.setState({ noOfShowMoreSAList: 3, showLessLink: false, showMoreLink: true,saFilteredList:[] });

        this.getDatas();

    }
    handleClickRatePlan = (item, name) => {
        name === 'rate' ? app.appService.setSessionstorage('rateType', `${item.currentServicePlan} ${item.billingRateType ? item.billingRateType : 'Non-NEM'}`) : null;
        app.appService.setSessionstorage('planType', this.props.custDetails.contractAccountStatus);
        let events = {
            alertDismissed:false, alertInteracted:false, manageAccount:false, makePayment:false, autoPayEnroll:false, paperlessEnroll:false, viewBill:false, viewUsage:false, custom:false, autopayCancel:false, paperlessCancel:false, sdpEnroll:false, sepEnroll:false, savingsPlan:false, paymentArrangement:false,componentClick:true,componentName:name === 'rate' ?  'Rate  plan' : 'service account' 
        },linkName= name === 'rate' ?  item.currentServicePlan : 'service_account_id';
        app.analyticsService.addPageLevelData('eventCapturing', events);
        window.aUtils ? window.aUtils.sendAAEvent("link", `settings|accounts|multi_grid|none|page|${linkName}`) : null;
        this.props.setSelectedSA(item, this.props.custDetails, name);
    }
    capitaliser = (mySentence) => {
        let words = mySentence.trim().split(" ");
        words.length <1 ? words.push(mySentence) : null;
        let reframedSentence = words.map((word) => {
            let reframed = word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
            return reframed; 
        }).join(" ");
        return reframedSentence;
    };
    getFormattedServAddress(servAddress={}){
        let unitNumAvailable =servAddress? servAddress.unitNumber !==''?servAddress.unitNumber:'':'';
        let formattedAddr = Object.entries(servAddress).map(([key,value])=>{
            let values = value;
            if(values!=='' && key!=='unitNumber'){    
                if(key!=="serviceaccountAddressNum" && key!=="serviceaccountStateCode" && key!=="serviceaccountZipcode"){
                    values = this.capitaliser(values);
                }
            let addComma = ((key ==='serviceaccountStreetAddress' && !unitNumAvailable)||(key ==='serviceaccountMailingCity'))?',':'';
            values = ((key ==='serviceaccountStreetAddress') && unitNumAvailable) ? values+', '+unitNumAvailable+', ':values;
            return values+addComma;} 
        }).join(' ');
        return formattedAddr;
    }
    getRatePlanLink = (item)=>{
        let donotDisplayRates= '#ADDFAC#CCADB#ESPDB#WIRETECH#DWLA#DWLB#DWLC#LS1#LS1MN#LS1-TAP#LS2A#LS2B#OL1#OL1-IDLE#EDWM#EDWT#T8D-EDW#T8D-MARCH#TG2D-EDW#TG3D-EDW#AL2#AL2F#LS3#TC1#PA1#PA2#TDT#GAS1#GAS2#GASM#W1GS#W1R#W1RCARE#W1RDS#W1RDSC#W1RM#W3#W4#';
        let showRatePlanText = donotDisplayRates.indexOf('#'+item.servicePlanHistoryData[0].servicePlanCode+'#') === -1 ?<CustomAnchorTag linkName={item.currentServicePlan} id='your_rate_plan_DSS' onClick={()=>this.handleClickRatePlan(item,"rate")} isUnderline />
        :<span className={styles.sceRatePlanText}>{item.currentServicePlan}</span>;
        return showRatePlanText;
    }
    getData = () => {

        let data = this.state.saFilteredList;
        return (
            <div className={styles.sceAccordianRowMngAcnt}>
                <div className={styles.sceMngFluidCardBlock}>
                    {
                        data.map((serviceAcctDetails, index) => {
                            return (
                                <div className={styles.sceMngFluidCard}>
                                    <div className={styles.sceMngFluidCardTop}>
                                        <div className={styles.sceMngFluidCardTopAddress} data-pii-encrypt>{this.getFormattedServAddress(serviceAcctDetails.serviceAccountAddress)}</div>

                                        <CustomStatusFlag serviceAccountStatusCode={serviceAcctDetails.serviceAccountStatusCode} />
                                    </div>
                                    <div className={styles.sceBottomFluidCard}>
                                        <div className={styles.sceBottomFluidSA}>Service Account: <span data-pii-encrypt className={styles.sceBottomFluidSASpan}><CustomAnchorTag id='service_account_id_DSS' linkName={serviceAcctDetails.contractNumber} onClick={() => { this.handleClickRatePlan(serviceAcctDetails, "service"); }} isUnderline /></span></div>
                                        <div className={styles.sceBottomFluidSA}>Rate Plan: <span className={styles.sceBottomFluidSASpan}>{this.getRatePlanLink(serviceAcctDetails)}</span></div>

                                    </div>
                                </div>
                            );
                        })
                    }

                </div>

                <div className={styles.sceAccordianNoOfData}>
                    {this.state.totalSACount > this.state.noOfSainRow && <div className={styles.sceAccordianShowingData}>Showing {data.length} of {this.state.totalSACount} Service Accounts</div>}

                    {this.state.totalSACount > this.state.noOfSainRow && this.state.showMoreLink && <div className={styles.sceAccordianShowingDataShowMore}><CustomAnchorTag linkName={'Show More'} isBold onClick={() => this.handleClickMore()} /></div>}
                    {this.state.totalSACount > this.state.noOfSainRow && this.state.showLessLink && <div className={styles.sceAccordianShowingDataShowMore}><CustomAnchorTag linkName={'Show Less'} isBold onClick={() => this.handleClickLess()} /></div>}
                </div>

            </div>
        );
    }

    render() {
        let data = this.getData();

        return (
            <span>
                {data}
            </span>
        );
    }
}

